import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import Box from '@repo/ui/box'
import { BuildingThreeIcon } from '@repo/ui/icons'
import Typography from '@repo/ui/typography'

import { getCenter } from '../../../../api/centers/get-center'
import { useDataProps } from '../../../../lib/hooks/use-data-props'
import { useNativeCountryName } from '../../../../lib/hooks/use-native-country-name'
import useTranslate from '../../../../lib/hooks/use-translate'
import { Center } from '../../../../lib/types/models/center/center'
import { DataProps } from '../../../../lib/types/utils'
import LabelWithText from '../../ols/label-with-text'

export function CenterAddresses(props: DataProps<Center>) {
  const { t } = useTranslate()
  const nativeCountryName = useNativeCountryName()
  const { data } = useDataProps(props, (id) => getCenter(id, 'FULL'))
  const journeyPlaces = data?.olJourneyPlace

  return (
    <Box style="border" className="bg-white-hover">
      <div className="flex flex-row items-center gap-2">
        <div className="w-8 h-8 flex items-center justify-center bg-secondary-light rounded p-1">
          <BuildingThreeIcon color={tailwindColors.secondary.DEFAULT} />
        </div>

        <Typography variant="text">{t('center.costs.address.title')}</Typography>
      </div>

      {!journeyPlaces ? (
        <div className="flex items-center justify-center">
          <Typography variant="tag" color={tailwindColors.grey.light.active}>
            {t('center.costs.address.no.data')}
          </Typography>
        </div>
      ) : (
        <div className="grid grid-cols-4 gap-2">
          <LabelWithText label={t('center.costs.address.name')} data={journeyPlaces?.name} />
          <LabelWithText
            label={t('center.costs.address.address')}
            data={[
              journeyPlaces.address1,
              journeyPlaces.address2,
              journeyPlaces.zipCode,
              journeyPlaces.city,
              nativeCountryName(journeyPlaces.country)
            ]
              .filter(Boolean)
              .join(', ')}
          />
          <LabelWithText
            label={t('center.costs.address.course.location')}
            data={!journeyPlaces?.isSameAddresForTuition ? journeyPlaces?.tuitionName : '-'}
          />
          <LabelWithText
            label={t('center.costs.address.course.address')}
            data={
              !journeyPlaces.isSameAddresForTuition
                ? [
                    journeyPlaces.tuitionAddress1,
                    journeyPlaces.tuitionAddress2,
                    journeyPlaces.tuitionZipCode,
                    journeyPlaces.tuitionCity,
                    nativeCountryName(journeyPlaces.tuitionCountry)
                  ]
                    .filter(Boolean)
                    .join(', ')
                : '-'
            }
          />
        </div>
      )}
    </Box>
  )
}
